// @ts-strict-ignore
import { ArticleTypeIds } from '../constants/article-type-ids';
import { ProjectType } from '@project/model/project-type';

export class ArticleTypeUtils {
  public static getAvailableArticleTypeIds(projectType: ProjectType): number[] {
    let result;
    switch (projectType) {
      case "MCS":
        result = [ArticleTypeIds.MULTI_CONNECTORS, ArticleTypeIds.MALE_HEADER_FOR_PCB, ArticleTypeIds.MCS_GDS_END_PLATE];
        break;
      case "GDS":
        result = [ArticleTypeIds.PCB_TERMINAL_BLOCKS, ArticleTypeIds.MCS_GDS_END_PLATE];
        break;
      default:
        result = [];
    }
    return result;
  }
}
